export default {
  code: {
    presence: { allowEmpty: false }
  },
  description: {
    presence: { allowEmpty: false }
  },
};
